var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-01
 * @brief EHP DashBoard  컴포넌트
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../recoil/userState";
import { loadingBoxState } from "../../recoil/menuState";
//utils
import * as CONST from "../../utils/Const";
import * as HTTPUTIL from "../../utils/api/HttpUtil";
import * as CUTIL from "../../utils/commUtils";
/**
* @brief EHP DashBoard 개발 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
function DndDashboardTree(props) {
    //trans, ref, navigate
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadinBox] = useRecoilState(loadingBoxState);
    // props
    //const locTree = props.locTree;
    const selTree = props.selTree;
    const setParentIsTreeOpen = props.setIsTreeOpen;
    const setParentSelTree = props.setSelTree;
    //
    const locTreeStr = localStorage.getItem(CONST.STR_EHP_DASHBODRD_PIN);
    const locTree = JSON.parse(locTreeStr);
    const [companyList, setCompanyList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [searchData, setSearchData] = useState({
        "searchText": null,
    });
    let searchQuery = "";
    //text검색
    if ((searchData.searchText) && (searchData.searchText.length > 0)) {
        searchQuery = searchQuery + `search=${searchData.searchText}`;
    }
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/dashboard/usertree?${searchQuery}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: searchQuery,
    });
    useEffect(() => {
        setRecoilIsLoadinBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retData) {
            setRecoilIsLoadinBox(false);
            //clog("IN DASHBOARD : EHCTREE : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                //const czoneStr = localStorage.getItem(CONST.STR_EHP_DASHBODRD_PIN);
                if (!CUTIL.isnull(locTree)) {
                    //clog("IN DND TREE : locTree : " + JSON.stringify(locTree));
                    //clog("IN DND TREE : selTREE : " + JSON.stringify(selTree));
                    (() => __awaiter(this, void 0, void 0, function* () {
                        const isExist = yield isExistCZone(locTree);
                        if (isExist) {
                            setParentSelTree(locTree);
                        }
                        else {
                            setParentSelTree(selTree);
                        }
                    }))();
                }
                setCompanyList(retData.body);
            }
        }
    }, [retData]);
    function isExistCZone(czone) {
        return __awaiter(this, void 0, void 0, function* () {
            let ret = false;
            let data = null;
            if (czone.zone.zoneId.length <= 0)
                return true;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/product/company/zone/${czone.zone.zoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data && data.codeNum === CONST.API_200) {
                ret = true;
            }
            return ret;
        });
    }
    function onClickCompanyZone(company, zone) {
        if (company === null) {
            setParentSelTree({
                "company": { "companyId": "", "companyName": "전체" },
                "zone": { "zoneId": "", "zoneName": "전체" },
                "reload": false
            });
        }
        else {
            setParentSelTree({
                "company": { "companyId": company.companyId, "companyName": company.companyName },
                "zone": { "zoneId": zone.zoneId, "zoneName": zone.zoneName },
                "reload": false
            });
        }
        setParentIsTreeOpen(false);
    }
    //clog("IN DND TREE : INIT : " + JSON.stringify(selTree) + " : LOC : " + JSON.stringify(locTree));
    function goSearch(e) {
        setSearchData({
            "searchText": searchText,
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lnb__top" },
            React.createElement("div", { className: "box__search" },
                React.createElement("input", { type: "text", placeholder: "\uD68C\uC0AC\uBA85\uC744 \uC785\uB825\uD558\uC138\uC694", value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                React.createElement("button", { type: "button", className: "btn btn-search", onClick: (e) => goSearch(e) },
                    React.createElement("span", { className: "hide" }, "\uC870\uD68C")))),
        (companyList.length > 0)
            ? React.createElement("div", { className: "lnb" },
                React.createElement("ul", { className: "lnb-depth1" },
                    React.createElement("li", { className: `${(selTree.zone.zoneId === "") ? "active" : ""}` },
                        React.createElement("p", null,
                            React.createElement("a", { onClick: (e) => onClickCompanyZone(null, null) }, " \uC804\uCCB4 "),
                            React.createElement("button", { type: "button", className: `btn btn-pin ${(locTree) && (locTree.zone.zoneId === "") ? "blue" : ""}` },
                                React.createElement("span", { className: "hide" }, "\uBA54\uC778 \uB300\uC2DC\uBCF4\uB4DC \uACE0\uC815")))),
                    companyList.map((company, cidx) => (company.hasOwnProperty("zone") && company.zone && company.zone.map((zone, zidx) => (React.createElement("li", { key: `li_${cidx.toString()}_${zidx.toString()}`, className: `${(selTree.zone.zoneId === zone.zoneId) ? "active" : ""}` },
                        React.createElement("p", null,
                            React.createElement("a", { onClick: (e) => onClickCompanyZone(company, zone) },
                                React.createElement("span", null, company.companyName),
                                React.createElement("span", null, zone.zoneName)),
                            React.createElement("button", { type: "button", className: `btn btn-pin ${(locTree) && (locTree.zone.zoneId === zone.zoneId) ? "blue" : ""}` },
                                React.createElement("span", { className: "hide" }, "\uBA54\uC778 \uB300\uC2DC\uBCF4\uB4DC \uACE0\uC815"))))))))))
            : React.createElement("div", { className: "lnb nodata" },
                React.createElement("div", { className: "nodata_txt" }, "\uAC80\uC0C9\uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."))));
}
export default DndDashboardTree;
